export default __webpack_public_path__ + "static/media/Honored Legguards of the Plains.3564ecae.jpg";